import BaseService from "./BaseService";
import http from './HttpService'
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/employee";
const cancelResignation = API_BASE_URL_ENV() + "/employee/cancelResignation";
const resignation = API_BASE_URL_ENV() + "/employee/resignation";
const apiDeleteDate = API_BASE_URL_ENV() + "/employee/deleteDate";
const apiBenefit = API_BASE_URL_ENV() + "/employee/benefit";
const apiNotification = API_BASE_URL_ENV() + "/employee/notification";
const apiProfile = API_BASE_URL_ENV() + "/employee/profile";

export default class EmployeesService extends BaseService {
  constructor() {
    super(apiEndpoint);
  }

  cancellationResignation(id) {
    return http.put(`${cancelResignation}/${id}`);
  }

  resignation(id, data) {
    return http.post(`${resignation}/${id}`, data);
  }

  notification() {
    return http.get(apiNotification);
  }

  profile(id) {
    return http.get(`${apiProfile}/${id}`);
  }

  endOfService(id, date) {
    return http.get(`${apiProfile}/${id}?end_date=${date}`);
  }

  updateAvatar(id, data) {
    return http.put(`${apiProfile}/imageProfile/${id}`, data);
  }

  benefit(data) {
    return http.post(apiBenefit, data);
  }

  updateDeleteDate(id, data) {
    const body = { ...data };
    return http.put(`${apiDeleteDate}/${id}`, body);
  }
}
